import { requestApi } from './helper';

export const SAVE_CUSTOMER_LIST = 'SAVE_CUSTOMER_LIST';

export const saveCustomerList = (customerList) => ({ type: SAVE_CUSTOMER_LIST, customerList });

export const requestCustomerList = () => requestApi('/customers', null, saveCustomerList);
